import { Stack, Typography } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import React, { useContext, useMemo, useState } from "react";
import { ReactComponent as LinkIcon } from "../../../assets/icons/link.svg";
import { DashboardContext } from "../../../contexts/DashboardContext";
import DashboardSavedLinksModal from "../../modals/dashboard-details/DashboardSavedLinksModal";

const useStyles = makeStyles((theme) => ({
    icon: {
        width: 36,
        height: 36,
        stroke: theme.colors.neutral['400'],
    },
    url: {
        fontFamily: 'Inter',
        fontWeight: 700,
        textDecoration: 'none',
        color: theme.palette.primary.main,
        cursor: 'pointer',
    },
    count: {
        fontFamily: 'Inter',
        fontWeight: 400,
        color: theme.colors.neutral['600'] ,
    },
}));

const SavedLinks: React.FC<{}> = () => {
    const classes = useStyles();
    const { dashboard } = useContext(DashboardContext);
    const [savedLinksModalOpen, setSavedLinksModalOpen] = useState<boolean>(false);

    const linksCount = useMemo(() => dashboard?.externalLinks?.length || 0, [dashboard]);

    if (!linksCount)
        return (<></>);

    return (<>
        <Stack direction="row" spacing={2} alignItems="center" justifyContent="flex-start" px={1}>
            <LinkIcon className={classes.icon} />
            <Typography className={classes.url}
                onClick={() => setSavedLinksModalOpen(true)}>
                {'Saved links  '}
                <Typography component="span" className={classes.count} display="inline">
                    {`(${linksCount})`}
                </Typography>
            </Typography>
        </Stack>
        {savedLinksModalOpen && (
            <DashboardSavedLinksModal
                open={savedLinksModalOpen}
                onClose={() => setSavedLinksModalOpen(false)} />
        )}
    </>);
}

export default SavedLinks;
